var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "#70A1E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1991 31.03C26.025 31.03 25.8508 30.9659 25.7133 30.8284C25.4475 30.5625 25.4475 30.1225 25.7133 29.8567L30.3058 25.2642C30.5716 24.9984 31.0116 24.9984 31.2775 25.2642C31.5433 25.53 31.5433 25.97 31.2775 26.2359L26.685 30.8284C26.5475 30.9567 26.3733 31.03 26.1991 31.03Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7916 26.4283H15.2083C14.8324 26.4283 14.5208 26.1167 14.5208 25.7408C14.5208 25.365 14.8324 25.0533 15.2083 25.0533H30.7916C31.1674 25.0533 31.4791 25.365 31.4791 25.7408C31.4791 26.1167 31.1674 26.4283 30.7916 26.4283Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2084 20.9467C15.0342 20.9467 14.8601 20.8825 14.7226 20.745C14.4567 20.4792 14.4567 20.0392 14.7226 19.7733L19.3151 15.1808C19.5809 14.915 20.0209 14.915 20.2867 15.1808C20.5526 15.4467 20.5526 15.8867 20.2867 16.1525L15.6942 20.745C15.5659 20.8733 15.3826 20.9467 15.2084 20.9467Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7916 20.9467H15.2083C14.8324 20.9467 14.5208 20.635 14.5208 20.2592C14.5208 19.8833 14.8324 19.5717 15.2083 19.5717H30.7916C31.1674 19.5717 31.4791 19.8833 31.4791 20.2592C31.4791 20.635 31.1674 20.9467 30.7916 20.9467Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfericon);
export default __webpack_public_path__ + "static/media/transfericon.0f06215e9122f79befb749d4a8d98451.svg";
export { ForwardRef as ReactComponent };